import styled from '@emotion/styled/macro'
import { css } from '@emotion/react'
import { getInputCursorStyle } from 'helpers/styles'

export const StyledValue = styled.span<{
  highlightPlaceholder?: boolean
  isPlaceholder?: boolean
}>`
  ${({ isPlaceholder, highlightPlaceholder, theme }) =>
    isPlaceholder
      ? css`
          color: ${highlightPlaceholder
            ? theme.primary
            : theme['secondary-500']};
        `
      : ''};
`

export const StyledDateTimePickerTrigger = styled.div<{
  isDisabled?: boolean
  isReadOnly?: boolean
}>`
  display: flex;
  align-items: center;

  ${({ isDisabled }) =>
    isDisabled
      ? css`
          background-color: var(--bs-secondary-bg) !important;
          opacity: 0.5;
        `
      : ''};
  cursor: ${getInputCursorStyle};
`
